import { graphql, useStaticQuery } from 'gatsby';

const GQL_SINGLE_PAGES = graphql`
  {
    allBwSinglePage {
      nodes {
        data
      }
    }
  }
`;

export default function useStrapiPageData(strapiPageName) {
  const { allBwSinglePage } = useStaticQuery(GQL_SINGLE_PAGES);

  const nodeData = allBwSinglePage.nodes.find(
    (node) => node.data.id === strapiPageName
  );

  const strapiPageData = nodeData?.data;
  const url = strapiPageData?.buildData?.slug;

  return [url, strapiPageData];
}
